module.exports = __webpack_public_path__ + "assets/smart-asset-instagram-active.2be4cce8.svg";